export const label = 'Додаткова інформація про відправлення';
export const maxLength = 100;
export const errors = {
  maxlength: `Максимальна довжина ${maxLength} символів`,
};
